import React from 'react';
import Modal from '../../../../components/Modal';
import TabbedCheckout from '../../../../apps/commerce/checkout/TabbedCheckout';

export default function PaymentForm({
  staticFileServer,
  paymentSuccess,
  close,
  showDialog,
  amount = 1000,
  currencySymbol = '£',
  localisations
}) {
  return (
    <Modal
      close={close}
      showDialog={showDialog}
      modalLabelText={'Get Boosts now'}
      id={'boosts-payment-forms'}
    >
      <TabbedCheckout
        staticFileServer={staticFileServer}
        paymentSuccess={paymentSuccess}
        amount={amount / 100}
        stripeButtonText={`Pay ${currencySymbol}${(amount / 100).toFixed(2)}`}
        localisations={localisations}
      />
    </Modal>
  );
}
